import type { Meta, StoryFn } from '@storybook/react';

import { Breadcrumbs, Card } from '@pega/cosmos-react-core';
import type { BreadcrumbsProps } from '@pega/cosmos-react-core';

import { StyledCard } from './Breadcrumbs.styles';
import { mockCopy } from './Breadcrumbs.mocks';

export default {
  title: 'Core/Breadcrumbs',
  component: Breadcrumbs
} as Meta;

interface StoryArgs {
  leafOnly?: BreadcrumbsProps['leafOnly'];
  longText?: boolean;
}

export const BreadcrumbsDemo: StoryFn<StoryArgs> = (args: StoryArgs) => {
  const crumbs = [
    {
      id: 'Plan information',
      primary: args.longText ? mockCopy[0] : 'Plan information',
      href: '#plan-information'
    },
    {
      id: 'View benefit',
      primary: args.longText ? mockCopy[1] : 'View benefit',
      href: '#view-benefit'
    },
    {
      id: 'Benefit usage',
      primary: args.longText ? mockCopy[2] : 'Benefit usage',
      href: '#benefit-usage'
    },
    {
      id: 'Plan claims',
      primary: args.longText ? mockCopy[3] : 'Plan claims',
      href: '#plan-claims'
    },
    {
      id: 'View benefit claims',
      primary: args.longText ? mockCopy[4] : 'View benefit claims'
    }
  ];

  return <Breadcrumbs path={crumbs} leafOnly={args.leafOnly} />;
};

BreadcrumbsDemo.args = {
  leafOnly: false,
  longText: false
};

BreadcrumbsDemo.argTypes = {
  leafOnly: { control: { type: 'boolean' } },
  longText: { control: { type: 'boolean' } }
};

export const ContainedBreadcrumbs: StoryFn<StoryArgs> = (args: StoryArgs) => {
  const crumbs = [
    { id: 'Plan information', primary: 'Plan information', href: '#plan-information' },
    {
      id: 'View benefit',
      primary: args.longText ? mockCopy[0] : 'View benefit',
      href: '#view-benefit'
    },
    { id: 'Benefit usage', primary: 'Benefit usage', href: '#benefit-usage' },
    { id: 'Plan claims', primary: 'Plan claims', href: '#plan-claims' },
    { id: 'View benefit claims', primary: args.longText ? mockCopy[1] : 'View benefit claims' }
  ];

  return (
    <Card as={StyledCard}>
      <Breadcrumbs path={crumbs} leafOnly={args.leafOnly} />
    </Card>
  );
};

ContainedBreadcrumbs.args = {
  leafOnly: false,
  longText: false
};

ContainedBreadcrumbs.argTypes = {
  leafOnly: { control: { type: 'boolean' } },
  longText: { control: { type: 'boolean' } }
};
